<div class="container">
  <div class="d-flex justify-content-between m-2">
    <h5 class="card-title my-auto">Booking ID: {{ bookingId() }}</h5>
    <button class="btn btn-sm text-danger" (click)="dialog.closeAll()">
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
  </div>
  <hr />
  <div class="mx-auto" style="width: 200px">
    <img
      class="card-img-top"
      *ngIf="imageAttachment()"
      [src]="getSafeUrl(imageAttachment())"
      alt="Attachment"
      style="width: 100%"
    />
  </div>
</div>
